/**
 * Font keys aligned with legacy Quill / formHtmlEditor.css (.ql-font-*).
 * Values are CSS font-family strings for TipTap FontFamily mark.
 */
export const FONT_CHOICE_KEYS = [
    'arial',
    'arial-black',
    'calibri',
    'cambria',
    'candara',
    'comic-sans',
    'consolas',
    'courier-new',
    'garamond',
    'georgia',
    'helvetica',
    'impact',
    'lucida-console',
    'monaco',
    'optima',
    'palatino',
    'bookman',
    'segoe-ui',
    'tahoma',
    'times-new-roman',
    'trebuchet-ms',
    'verdana',
];

export const FONT_FAMILY_CSS_BY_KEY = {
    arial: 'Arial, Helvetica, sans-serif',
    'arial-black': "'Arial Black', Arial, Helvetica, sans-serif",
    calibri: `Calibri, Candara, 'Segoe UI', Arial, sans-serif`,
    cambria: `Cambria, Georgia, 'Times New Roman', serif`,
    candara: `Candara, Calibri, 'Segoe UI', Arial, sans-serif`,
    'comic-sans': `'Comic Sans MS', 'Comic Sans', cursive, sans-serif`,
    consolas: `Consolas, 'Lucida Console', Monaco, monospace`,
    'courier-new': `'Courier New', Courier, monospace`,
    garamond: `Garamond, Baskerville, 'Times New Roman', serif`,
    georgia: `Georgia, 'Times New Roman', serif`,
    helvetica: 'Helvetica, Arial, sans-serif',
    impact: `Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif`,
    'lucida-console': `'Lucida Console', Monaco, monospace`,
    monaco: `Monaco, Consolas, 'Lucida Console', monospace`,
    optima: `Optima, 'Segoe UI', Candara, Calibri, sans-serif`,
    palatino: `Palatino, 'Palatino Linotype', 'Book Antiqua', serif`,
    bookman: `Bookman, 'Bookman Old Style', 'URW Bookman', Georgia, serif`,
    'segoe-ui': `'Segoe UI', Tahoma, Geneva, Verdana, sans-serif`,
    tahoma: `Tahoma, 'Segoe UI', Verdana, sans-serif`,
    'times-new-roman': `'Times New Roman', Times, serif`,
    'trebuchet-ms': `'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', Arial, sans-serif`,
    verdana: 'Verdana, Geneva, sans-serif',
};

function humanizeKey(key) {
    return key
        .split('-')
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
}

/** Options for QSelect: default + each font CSS value */
export function buildFontFamilySelectOptions() {
    const opts = [{ label: 'Default', value: '' }];
    for (const key of FONT_CHOICE_KEYS) {
        const css = FONT_FAMILY_CSS_BY_KEY[key];
        opts.push({ label: humanizeKey(key), value: css });
    }
    return opts;
}
